<script>
  import { createEventDispatcher, getContext } from "svelte";
  import NauiInput from "../../../lib/naui/atoms/NauiInput.svelte";
  import "../../../../static/front/css/lib/astillero/_formAud.css";
  import { onMount } from "svelte";
  import NauiButton from "../../../lib/naui/atoms/NauiButton.svelte";
  import { writable } from "svelte/store";
  import {maxLenghtInput} from "../../../lib/utils/index";
  import {allowPositiveValues} from "../../../lib/utils/index";
  

  const dispatch = createEventDispatcher();

  export let onGuardar;
  export let data;
  export let count_row; 
  export let hasError;


  let tallasUnicas = [];
  let tallasData = Array.from({ length: count_row }, () => ({
    color: "",
    talla_cantidad: Array.from({ length: 14 }, () => ({
      talla: "",
      cantidad: 0,
    })),
    total_cantidad: 0,
  }));

  let errorMessage = "";

  onMount(() => {
    tallasUnicas = data.lista_tallas_unicas;
    data = data.lista_talla_colores;

    if (data && Array.isArray(data) && data.length > 0) {
      tallasData = tallasData.map((item, index) => {
        if (data[index]) {
          return {
            color: data[index].color || item.color,
            talla_cantidad: Array.from({ length: 14 }, (_, tallaIndex) => {
              const talla = tallasUnicas[tallaIndex] || "";
              const foundTalla =
                data[index].talla_cantidad.find((t) => t.talla === talla) || {};
              return {
                talla: talla,
                cantidad: foundTalla.cantidad || 0,
              };
            }),
            total_cantidad: data[index].total_cantidad || item.total_cantidad,
          };
        }
        return item;
      });
    }
    actualizarDatos();
  });

  function agregarFila() {
    count_row++;
    tallasData = [
      ...tallasData,
      {
        color: "",
        talla_cantidad: tallasData[0].talla_cantidad.map((t) => ({
          talla: t.talla,
          cantidad: 0,
        })),
        total_cantidad: 0,
      },
    ];

    actualizarDatos();
  }

  function eliminarFila(index) {
    if (count_row > 6) {
      count_row--;
      tallasData = tallasData.filter((_, i) => i !== index);
      actualizarDatos();
    }
  }

  function actualizarTotal(index) {
    tallasData[index].total_cantidad = tallasData[index].talla_cantidad.reduce(
      (sum, item) => sum + (item.cantidad || 0),
      0
    );
    actualizarDatos();
  }

  function actualizarTalla(index, tallaIndex, field, value) {
    if (field === "talla") {
      for (let i = 0; i < tallasData.length; i++) {
        tallasData[i].talla_cantidad[tallaIndex].talla = value;
      }
      actualizarDatos();
      return;
    }
    tallasData[index].talla_cantidad[tallaIndex][field] = value;

    actualizarTotal(index);
  }
  function actualizarColor(index, value) {
    tallasData[index].color = value;
    actualizarDatos();
  }

  function obtenerDatos() {
    const lista_talla_colores = tallasData
      .map((item) => ({
        color: item.color,
        talla_cantidad: item.talla_cantidad.filter((t) => t.cantidad > 0),
        total_cantidad: item.total_cantidad,
      }))
      .filter((item) => item.color && item.talla_cantidad.length > 0);
    return lista_talla_colores;
    
  }

  function validarDatos() {
    errorMessage = "";

    tallasData.forEach((item, index) => {
      if (item.total_cantidad > 0 && !item.color) {
        errorMessage = "Hay unidades sin un color asociado.";
        return false;
      }
      item.talla_cantidad.forEach((talla, tallaIndex) => {
        if (talla.cantidad > 0 && !talla.talla) {
          errorMessage = "Hay unidades sin una talla asociada.";
          return false;
        }
      });
    });
    return true;
  }

  function actualizarDatos() {
    const lista_talla_colores = {
      lista_talla_colores: obtenerDatos(),
    };
    if (validarDatos()) {
      dispatch("update", { label: "Tallas", data: lista_talla_colores });
    }
  }


  $: {
    if(
      errorMessage
    )
    {
     
      hasError.update(errors => errors.filter(error => error !== 'Unidad Talla-Color'));
      hasError.update(errors => [...errors, 'Unidad Talla-Color']);
    }else{
      hasError.update(errors => errors.filter(error => error !== 'Unidad Talla-Color'));
    }
  }

</script>

<div class="containerMain">

  {#if errorMessage}
    <div class="error-message">{errorMessage}</div>
  {/if}

  <div class="containerTallas">
    <div class="content-fixed">
      <div class="color-unid">
        <div class="color">
          <p class="tittle-text">COLOR</p>
        </div>
        <div class="unid">
          <p class="tittle-text">UNID X COLOR</p>
        </div>
      </div>

      <div class="talla-unidades">
        <div class="talla-item">
          <p class="tittle-text">TALLAS Y UNIDADES</p>
          <NauiButton
            caption="+"
            color="accent"
            mode="outline"
            on:click={agregarFila}
          />
        </div>
        <div class="tallas-cantidad">
          {#each tallasData[0].talla_cantidad as talla, tallaIndex}
            <NauiInput
              class='tallas-style'
              label=""
              type="text"
              id='talla-{tallaIndex}'
              placeholder={talla.talla || "talla"}
              bind:value={talla.talla}
              on:input={(e) => {
                maxLenghtInput(e, 20);
                actualizarTalla(0, tallaIndex, "talla", e.target.value);
              }}
            />
          {/each}
        </div>
      </div>
    </div>

    <div class="contentData">
      {#each tallasData as item, index}
        <div class="content-inputs">
          <div class="talla-buttons">
            <NauiButton
              icon="disabled_by_default"
              mode="outline"
              color="accent"
              iconStyle="outlined"
              on:click={() => eliminarFila(index)}
            />
          </div>
          <div class="input-colors">
            <NauiInput
              class='inputs-styles {item.total_cantidad > 0 && !item.color ? "red-border !important" : ""}'
              label=""
              type="text"
              placeholder="color"
              max
              bind:value={item.color}
              on:input={(e) => {
                maxLenghtInput(e, 255);
                actualizarColor(index, e.target.value)
              }}
            />
            <NauiInput
              class="inputs-styles"
              label=""
              type="number"
              isDisabled
              bind:value={item.total_cantidad}
              readonly
            />
          </div>
          <div class="input-tallas">
            {#each item.talla_cantidad as talla, tallaIndex}
              <NauiInput
                class='tallas-style {talla.cantidad > 0 && !talla.talla ? "red-border" : ""}'
                label=""
                type="number"
                min = 0
                id='talla-{index}-{tallaIndex}'
                bind:value={talla.cantidad}
                on:input={(e) => {
                  maxLenghtInput(e, 9);
                  allowPositiveValues(e);
                  actualizarTalla(
                    index,
                    tallaIndex,
                    "cantidad",
                    parseInt(e.target.value)
                  );
                }}
              />
            {/each}
          </div>
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
  .containerTallas {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: white;
  }

  .talla-buttons {
    width: 5%;
    align-items: center;
  }

  .contentData {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .content-fixed {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .color-unid,
  .input-colors {
    width: 20%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .color,
  .unid {
    width: 48%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: end;
  }

  .talla-unidades{
    width: 76%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .tallas-cantidad {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  :global(.tallas-style.naui-field) {
    width: 8%;
  }

  :global(.tallas-style input::placeholder) {
    color: #d1cfcf;
  }
  :global(.inputs-styles input::placeholder) {
    color: #d1cfcf;
  }

  :global(.inputs-styles.naui-field) {
    width: 49%;
  }
  
  :global(.red-border.naui-field input) {
    border: 1px solid #ff5a5f;
  }
  .content-inputs {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .input-tallas {
    width: 80%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .red-border {
    border: 1px solid red;
  }

  .error-message {
    color: red;
    font-weight: bold;
    margin: 10px 0;
  }
</style>
